import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { addedToCartEvents } from '../shared/cart-events';
import { OptionModalData } from '../shared/extras';

/**
 * Legacy extras popup (`app-popup`), used by the legacy recipe card, legacy
 * dine-in, the products pages and — with `TemplateData.NewDesign` off —
 * `ProductCardService`. The redesign opens `recipe-option-modal` instead.
 *
 * The extras parsing helpers live in `shared/extras.ts` (shared with the
 * options modal) and are re-exported here for the legacy importers.
 */
@Injectable({
  providedIn: 'root',
})
export class popupService {
  popUpData = new Subject<popupData>();
  /** Same Subject as RecipeOptionModalService.addedToCart$ (shared/cart-events.ts). */
  addedToCartSuccessful: Subject<any> = addedToCartEvents;
}

/** Same shape as the options modal's input. */
export type popupData = OptionModalData;

export {
  EXTRA_SELECTION_KEYWORDS,
  resolveExtraSelectionType,
  isRequiredExtraGroup,
  countRequiredExtraGroups,
  toRenderedExtraGroup,
  toRenderedExtraList,
} from '../shared/extras';
